<template>
  <div>
    <div>
      <aha-modal
        priority="high"
        :closable="false"
        v-if="!isTokenValid"
        action-position="justify-center"

        :title="$i18nPresenter.t('It looks like you have been logged out')"
      >
        <div>
          {{ textRemaining }}
        </div>

        <template #action>
          <aha-antd-button
            v-aha-emit-action
            name="invalid-token-login-again-button"
            data-testid="invalid-token-modal-login-again-button"
            @click="handleLogoutAgainButtonClick()"
          >
            {{ $i18nPresenter.t('Login again') }}
          </aha-antd-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// config
import configs from '@/config'

// utils
import utils from '@/util'

export default {
  data() {
    return {
      remainingSeconds: null,
      textRemaining: '',
    }
  },
  computed: mapState({
    currentUser: (state) => state.currentUser,
    isTokenValid: (state) => state.isTokenValid,
  }),
  watch: {
    // when token is invalid, a popup show to the user
    // and the application redirect to login page in 7s
    isTokenValid() {
      if (!this.isTokenValid) {
        const url = configs.accountRemovalURL
        if (window.location.href === url) {
          return
        }
        this.remainingSeconds = 7

        setInterval(() => {
          if (this.remainingSeconds === 0) {
            this.handleLogoutAgainButtonClick()
          }

          if (this.remainingSeconds > 0) {
            this.remainingSeconds--
            this.textRemaining = this.$i18nPresenter.t('You will be directed to the Login screen in {remainingSeconds} seconds', {
              remainingSeconds: this.remainingSeconds,
            })
          }
        }, 1000)
      }
    },
  },
  methods: {
    handleLogoutAgainButtonClick() {
      utils.logout(this.currentUser)
    },
  },
}
</script>
